module.exports = __webpack_public_path__ + "static/media/apartment.fcfab9d5.svg";